<template>
  <div class="feedback-list" :class="{'feedback-list-check': data.check}" @click="onCheckFeedback(data.id)">
    <div class="title">{{data.title}}</div>
    <div class="create-time">
      {{ data.userName }} ({{data.mobile}}) 提交于 {{data.create_time}}
    </div>
    <div class="content">{{data.content}}</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    onCheckFeedback(res) {
      this.$emit('feedbackId', res);
    }
  }
};
</script>

<style lang="scss" scoped>
  .feedback-list {
    padding: 16px;
    border: 1px solid #e5e6ee;
    .title {
      margin-bottom: 16px;
      color: #171f46;
      font-size: 16px;
      font-weight: 500;
    }
    .create-time {
      margin-bottom: 16px;
      color: #747990;
      font-size: 12px;
      font-weight: 500;
    }
    .content {
      color: #747990;
      font-size: 14px;
    }
  }
  .feedback-list-check {
    border: 1px solid #2b76ff;
  }
</style>
